import { DinnerSuggestionsImportantToMeOption, DinnerSuggestionsMoreOfOption } from "./types"

export const dinnerSuggestionsMoreOfOptions: DinnerSuggestionsMoreOfOption[] = [
    { id: "fish", label: "Fisk", illustration: "fish" },
    { id: "vegetarian", label: "Vegetar", illustration: "vegetarian" },
    { id: "chicken", label: "Kylling", illustration: "chicken" },
    { id: "meat", label: "Kjøtt", illustration: "meat" },
]

export const dinnerSuggestionsImportantToMeOptions: DinnerSuggestionsImportantToMeOption[] = [
    { id: "healthier", label: "Sunnere", description: "Grønnere, grovere, renere" },
    { id: "save-time", label: "Spare tid", description: "Under 30 min å lage" },
    { id: "simple", label: "Enkel", description: "Få ingredienser" },
    { id: "family-friendly", label: "Barnevennlig", description: "Trygge smaker og enkle retter" },
]
